import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { DeviceGroupService } from 'src/app/Service/DeviceGroup/DeviceGroup.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';
import * as XLSX from 'xlsx';

@Component({
  selector: 'app-DeviceBehfaList',
  templateUrl: './DeviceBehfaList.component.html',
  styleUrls: ['./DeviceBehfaList.component.scss']
})
export class DeviceBehfaListComponent implements OnInit {

  Token:String=""
  Filter_Description:string=""
  Filter_Model:string=""
  Filter_Manufacturer:string=""
  Filter_Code:string=""

  Operation_Dsc:string=""


  ids:String="-1"

  order:string='id'
  orderreverse :boolean=true

  page:number=0
  PageIndex:number
  Procssing:boolean=false
  BaseUrl=environment.Print_URL+"QRCodeDeviceBehfaFilter/"
  BaseUrl2=environment.Print_URL+"QRCodeDeviceBehfaFilter2/"
  BaseUrlFilter=environment.Print_URL+"QRCodeDeviceBehfaFilter?ids="+this.ids
  BaseUrlFilter2=environment.Print_URL+"QRCodeDeviceBehfaFilter2?ids="+this.ids

  modalRef_Delete: any;

  constructor(
    private DeviceBehfa_Service:DeviceBehfaService,
    private Alertify_Service:AlertifyService,
    private Nav_Service:NavService,
    private DeviceGroup_Service:DeviceGroupService,
    private modalService: BsModalService
  ) { }

  ChangeOrder(item:string)
  {
    this.order=item
    this.orderreverse=!this.orderreverse
  }

  DataList_DeviceBehfa_Type:number=-1
  Data_Change_Operaion_Id:number=-1
  Data_Change_Operaion_Submit:boolean=true
  Data_Change_Service:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()
  Data_Change_Operation:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()
  DataList_DeviceBehfa: Array<DeviceBehfa_Interface> = []

  DataList_DeviceBehfa_Total: Array<DeviceBehfa_Interface> = []

  two_Month_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  one_Month_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  zero_Month_DeviceBehfa: Array<DeviceBehfa_Interface> = []

  activeStatus_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  disactiveStatus_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  repairStatus_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  calibrationStatus_DeviceBehfa:Array<DeviceBehfa_Interface>=[]
  outorderStatus_DeviceBehfa:Array<DeviceBehfa_Interface>=[]


  Data_Seleted_Delete:DeviceBehfa_Interface=Empty_DeviceBehfa_Interface()

  ngOnInit() {
    this.Token=localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token,46).subscribe(
      data=>{
        this.Read_First_Device_Group()
        //this.ReadData_DeviceBehfa_Count()
        //this.ReadData_DeviceBehfa()
      }
      ,error=>{
        localStorage.clear()
        location.reload();
      }
    )


  }

  Delete(item:DeviceBehfa_Interface,id){

    if(!this.Operation_Dsc){
      this.Alertify_Service.ErrorMessage("Enter the description.")
    }
    else{

      this.modalRef_Delete.hide()
      this.DeviceBehfa_Service.DeleteDevice(item.id,id,this.Operation_Dsc,this.Token).subscribe(
        data=>{
          if(item.status==4)
            this.Alertify_Service.SuccessMessage("Marked as under calibration.")
          else if(item.status==3)
            this.Alertify_Service.SuccessMessage("Marked as under repair.")
          else if(item.status==2)
            this.Alertify_Service.SuccessMessage("Deactivated successfully.")
          else
            this.Alertify_Service.SuccessMessage("Activated successfully.")

          this.Data_Seleted_Delete.status=id
          //this.ReadData_DeviceBehfa()
        },error=>{
          localStorage.clear()
          location.reload();

        }
        )
      }
  }

  Set_Change_Operaion(item:number){
    this.Data_Change_Operaion_Id=item
  }

  Set_Change_Service(item:DeviceBehfa_Interface){
    this.Data_Change_Service=item
  }

  Set_Data_Change_Operation(item:DeviceBehfa_Interface){
    this.Data_Change_Operation=item
  }

  OnBack_Change_Operaion(item:any) {
    this.Data_Change_Operaion_Id=-1
  }

  OnBack_Change_Service(){
    this.Data_Change_Service=Empty_DeviceBehfa_Interface()
  }

  OnBack_Change_Operation(){
    this.Data_Change_Operation=Empty_DeviceBehfa_Interface()
  }

  Paging_Button=[]
  ReadData_DeviceBehfa(PageIndex:number){
    this.Procssing=true

    this.Paging_Button=[]
    this.DeviceBehfa_Service.GetRecord(this.Filter_Description,
      this.Filter_Manufacturer,
      this.Filter_Model,
      this.Filter_Code,
      Number(this.First_Device_Group_Selected),
      Number(this.Second_Device_Group_Selected),
      PageIndex,
      this.Token).subscribe(
      data=>{
        this.Procssing=false
        this.PageIndex=PageIndex

        this.DataList_DeviceBehfa_Type=-1

        this.Paging_Button=Array(data['pageSize']).fill(1).map((x, i) => i + 1);
        this.DataList_DeviceBehfa = data['result']

        this.DataList_DeviceBehfa_Total =this.DataList_DeviceBehfa

        this.two_Month_DeviceBehfa=data['twoMonth']
        this.one_Month_DeviceBehfa=data['oneMonth']
        this.zero_Month_DeviceBehfa=data['zeroMonth']

        this.activeStatus_DeviceBehfa = data['activeStatus']
        this.disactiveStatus_DeviceBehfa = data['disactiveStatus']
        this.repairStatus_DeviceBehfa = data['repairStatus']
        this.calibrationStatus_DeviceBehfa = data['calibrationStatus']
        this.outorderStatus_DeviceBehfa = data['outorderStatus']
      },error=>{
        localStorage.clear()
        location.reload();

      }
    )
  }


  Change_Filter_title(){
    this.page=0
    this.BaseUrlFilter=environment.Print_URL+"QRCodeDeviceBehfaFilter/"+this.ids
    this.BaseUrlFilter2=environment.Print_URL+"QRCodeDeviceBehfaFilter2/"+this.ids
  }

  //#region  CheckAll

  Check_All:boolean=false
  onChange_CheckAll(){
    this.Check_All=!this.Check_All
    if(this.Check_All)
    {
      for(let item of this.DataList_DeviceBehfa)
      {
        item.selected=true
      }
    }
    else{
      for(let item of this.DataList_DeviceBehfa)
      {
        item.selected=false
      }
    }

    this.set_Selected_Subscription()
  }

  onChange_CheckItem(item:DeviceBehfa_Interface)
  {
    item.selected=!item.selected
    if(item.selected==false)
    {
      this.Check_All=false
    }

    this.set_Selected_Subscription()
  }

  set_Selected_Subscription(){
    this.ids='-1'
    for(let item of this.DataList_DeviceBehfa)
    {
      if(item.selected)
      {
        this.ids=this.ids+","+item.id
      }
    }
    this.BaseUrlFilter=environment.Print_URL+"QRCodeDeviceBehfaFilter/"+this.ids
    this.BaseUrlFilter2=environment.Print_URL+"QRCodeDeviceBehfaFilter2/"+this.ids
  }

  //#endregion


  openModal_Status:number=0
  openModal(template: TemplateRef<any>,Record,status) {
    this.Data_Seleted_Delete=Record
    this.openModal_Status=status
    this.modalRef_Delete = this.modalService.show(template);
  }


  exportexcel(): void
  {
     /* table id is passed over here */
     let element = document.getElementById('excel-table');
     const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);

     /* generate workbook and add the worksheet */
     const wb: XLSX.WorkBook = XLSX.utils.book_new();
     XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

     /* save to file */
     XLSX.writeFile(wb, "DaroDevice.xlsx");

  }



  Set__filter_DeviceBehfa_DataList(Model:Array<DeviceBehfa_Interface>,Type:number){
    this.DataList_DeviceBehfa = Model
    this.page=0
    this.DataList_DeviceBehfa_Type=Type
  }





  //#region Device Group

  DataList_First_Device_Group:Array<General_Interface>=[]
  DataList_Second_Device_Group:Array<General_Interface>=[]

  First_Device_Group_Selected:string='0'
  Second_Device_Group_Selected:string='0'

  Read_First_Device_Group(){
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,0).subscribe(
      data=>{
        this.DataList_First_Device_Group=data
      }
    )
  }

  Read_Second_Device_Group(){
    this.Second_Device_Group_Selected="0"
    this.DeviceGroup_Service.GetDeviceGroup(this.Token,Number(this.First_Device_Group_Selected)).subscribe(
      data=>{
        this.DataList_Second_Device_Group=data
      }
    )
  }

  //#endregion

}
